import { withTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Discovery from 'components/discovery/Discovery';

import HeaderButtonsModal from 'components/modals/HeaderButtonsModal/HeaderButtonsModal';
import { CloseButton, KgButton } from 'components/modals/HeaderButtonsModal/Buttons';

import { changeUrlGivenCurrentQueryParams } from 'components/LinkWithQuery';

const DiscoveryModal = ({ t }) => {
  const history = useHistory();

  const closeModal = () => changeUrlGivenCurrentQueryParams(history, { showDialog: null });

  const handleKeyDown = event => {
    if (event.key === 'Escape') {
      closeModal();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <HeaderButtonsModal
      leftButton={<KgButton />}
      title={t('discovery-description')}
      rightButton={<CloseButton />}
      content={<Discovery />}
    />
  );
};

export default withTranslation('veezoo')(DiscoveryModal);
